import React, { Component } from 'react';
// utils
import moment from 'moment';
// components
import Datepicker from '../../../components/Datepicker/Datepicker';
import FieldError from '../../../components/Form/FieldError';

class DateInput extends Component {
  render() {
    const {
      setFieldTouched,
      setFieldValue,
      errors,
      values,
      data: { content }
    } = this.props;
    const { id } = content;
    return (
      <div>
        <Datepicker
          onChange={value => setFieldValue(id, value.format())}
          onBlur={() => setFieldTouched(id, true)}
          selected={moment(values[id])}
          invalid={errors[id]}
        />
        <FieldError error={errors[id]} touched={true} />
      </div>
    );
  }
}

export default DateInput;



// WEBPACK FOOTER //
// ./src/containers/Module/components/DateInput.jsx